import { gql } from '@apollo/client';

export const WorkflowStateFragment = gql`
  fragment WorkflowState on WorkflowState {
    status
    updated_at
    data_availability {
      combined
    }
    risks
  }
`;
/*
fully expanded fragment for reference
/*
export const WorkflowStateFragment = gql`
  fragment WorkflowState on WorkflowState {
    id
    status
    updated_at
    last_pipeline_run
    data_availability {
      combined
      data_availability {
        IP_ownership
        company_overview
        compliance
        data_governance
        data_licensing_AI
        security
        technical_team
        technology_stack
      }
    }
  }
`;
*/
